var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150.05 112.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 6.19,
    x2: 95.53,
    y1: 15.53,
    y2: 102.87
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#315050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ACA5"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 28.79,
    x2: 118.13,
    xlinkHref: "#a",
    y1: -7.58,
    y2: 79.75
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 7.88,
    x2: 97.21,
    xlinkHref: "#a",
    y1: 13.81,
    y2: 101.14
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 11.04,
    x2: 100.38,
    xlinkHref: "#a",
    y1: 10.57,
    y2: 97.91
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 14.2,
    x2: 103.54,
    xlinkHref: "#a",
    y1: 7.34,
    y2: 94.67
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 2.86,
    x2: 92.19,
    xlinkHref: "#a",
    y1: 18.94,
    y2: 106.28
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 5.54,
    x2: 94.87,
    xlinkHref: "#a",
    y1: 16.2,
    y2: 103.53
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(.98416469 .17725651 -.17725651 .98416469 14.6 -6.3)",
    x1: -7.55,
    x2: 81.78,
    xlinkHref: "#a",
    y1: 29.59,
    y2: 116.92
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(.17725651 .98416469 -.98416469 .17725651 126.66 5.64)",
    x1: 0.95,
    x2: 90.29,
    xlinkHref: "#a",
    y1: 20.89,
    y2: 108.23
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 1.99,
    x2: 91.33,
    xlinkHref: "#a",
    y1: 19.83,
    y2: 107.16
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -10.02,
    x2: 79.31,
    xlinkHref: "#a",
    y1: 32.12,
    y2: 119.45
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -13.53,
    x2: 75.8,
    xlinkHref: "#a",
    y1: 35.71,
    y2: 123.04
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -17.04,
    x2: 72.29,
    xlinkHref: "#a",
    y1: 39.3,
    y2: 126.64
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -17.33,
    x2: 72,
    xlinkHref: "#a",
    y1: 39.6,
    y2: 126.93
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 20.71,
    x2: 110.04,
    xlinkHref: "#a",
    y1: 0.69,
    y2: 88.02
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientTransform: "matrix(.96597098 .25865046 -.25865046 .96597098 9.64 -10.14)",
    x1: 16.34,
    x2: 105.67,
    xlinkHref: "#a",
    y1: 5.16,
    y2: 92.49
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientTransform: "matrix(.86611266 .49984884 -.49984884 .86611266 22.13 -13.37)",
    x1: 11.22,
    x2: 100.56,
    xlinkHref: "#a",
    y1: 10.39,
    y2: 97.72
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientTransform: "matrix(.70710678 .70710678 -.70710678 .70710678 36.61 -9.45)",
    x1: 5.72,
    x2: 95.05,
    xlinkHref: "#a",
    y1: 16.02,
    y2: 103.35
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientTransform: "matrix(.50015114 .86593812 -.86593812 .50015114 52.07 1.35)",
    x1: 0.2,
    x2: 89.53,
    xlinkHref: "#a",
    y1: 21.66,
    y2: 109
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientTransform: "matrix(.25865046 .96597098 -.96597098 .25865046 67.49 18.3)",
    x1: -4.96,
    x2: 84.37,
    xlinkHref: "#a",
    y1: 26.94,
    y2: 114.28
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -9.41,
    x2: 79.92,
    xlinkHref: "#a",
    y1: 31.49,
    y2: 118.83
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientTransform: "matrix(.96592583 .25881905 -.25881905 .96592583 18.57 -3.3)",
    x1: -12.85,
    x2: 76.49,
    xlinkHref: "#a",
    y1: 35.01,
    y2: 122.34
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientTransform: "matrix(.86611266 .49984884 -.49984884 .86611266 41.45 -2.22)",
    x1: -15.03,
    x2: 74.3,
    xlinkHref: "#a",
    y1: 37.24,
    y2: 124.58
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientTransform: "matrix(.70723018 .70698336 -.70698336 .70723018 67.06 3.17)",
    x1: -15.82,
    x2: 73.51,
    xlinkHref: "#a",
    y1: 38.05,
    y2: 125.38
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientTransform: "matrix(.70735356 .70685991 -.70685991 .70735356 79.67 -27.29)",
    x1: 5.24,
    x2: 94.57,
    xlinkHref: "#a",
    y1: 16.51,
    y2: 103.85
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    gradientTransform: "matrix(.50015114 .86593812 -.86593812 .50015114 104.84 -29.11)",
    x1: 10.76,
    x2: 100.09,
    xlinkHref: "#a",
    y1: 10.87,
    y2: 98.2
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientTransform: "matrix(.25881905 .96592583 -.96592583 .25881905 126.35 -26.86)",
    x1: 15.92,
    x2: 105.25,
    xlinkHref: "#a",
    y1: 5.59,
    y2: 92.92
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 20.37,
    x2: 109.7,
    xlinkHref: "#a",
    y1: 1.04,
    y2: 88.37
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientTransform: "matrix(.96592583 .25881905 -.25881905 .96592583 16.5 -19.07)",
    x1: 23.8,
    x2: 113.13,
    xlinkHref: "#a",
    y1: -2.48,
    y2: 84.86
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientTransform: "matrix(.8660254 .5 -.5 .8660254 33.29 -32.69)",
    x1: 25.99,
    x2: 115.32,
    xlinkHref: "#a",
    y1: -4.71,
    y2: 82.62
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientTransform: "matrix(.70710678 .70710678 -.70710678 .70710678 49.23 -39.91)",
    x1: 26.78,
    x2: 116.11,
    xlinkHref: "#a",
    y1: -5.52,
    y2: 81.81
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientTransform: "matrix(.49969767 .86619988 -.86619988 .49969767 63.25 -40.27)",
    x1: 26.11,
    x2: 115.45,
    xlinkHref: "#a",
    y1: -4.84,
    y2: 82.49
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientTransform: "matrix(.25898763 .96588064 -.96588064 .25898763 74.32 -33.72)",
    x1: 24.04,
    x2: 113.38,
    xlinkHref: "#a",
    y1: -2.73,
    y2: 84.61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h150.05v112.2h-150.05z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m102.5 101.03h-32.5v-4h28.5v-74.91h-94.5v74.91h28.5v4h-32.5v-82.91h102.5z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m102.5 22.12h-102.5v-15.5h102.5zm-98.5-4h94.5v-7.5h-94.5z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m6.5 12.29h3.74v4h-3.74z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m12.97 12.29h3.74v4h-3.74z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m19.44 12.29h3.74v4h-3.74z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m65.26 93.74h-28.07l-.13-1.87a12.2 12.2 0 0 0 -1.7-6.16c-9.68-12.46-10-24.44-10-24.56a25.85 25.85 0 1 1 51.7 0c0 .12-.28 12.09-10 24.59a12.34 12.34 0 0 0 -1.72 6.15zm-24.39-4h20.74a13.9 13.9 0 0 1 2.33-6.43c8.85-11.4 9.15-22.06 9.16-22.16a21.85 21.85 0 1 0 -43.7 0c0 .1.3 10.76 9.14 22.14a13.85 13.85 0 0 1 2.33 6.45z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m35.73 61.06h-4a19.5 19.5 0 0 1 19.52-19.43v4a15.49 15.49 0 0 0 -15.52 15.43z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m40.55 65.26h4v26.63h-4z",
    fill: "url(#h)",
    transform: "matrix(.98416469 -.17725651 .17725651 .98416469 -13.26 8.79)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m46.64 76.57h26.63v4h-26.63z",
    fill: "url(#i)",
    transform: "matrix(.17725651 -.98416469 .98416469 .17725651 -28 123.65)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m51.24 71.32-3.63-2-3.64 2-4.6-2.53 1.93-3.5 2.67 1.47 3.64-2 3.63 2 3.64-2 3.64 2 2.68-1.47 1.93 3.51-4.61 2.52-3.64-2z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m35.75 90.02h31.01v4h-31.01z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m35.75 97.04h31.01v4h-31.01z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m40.94 104.07h20.62v4h-20.62z",
    fill: "url(#m)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m37.34 92.34h4v5.34h-4z",
    fill: "url(#n)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m49.25 28.18h4v4.73h-4z",
    fill: "url(#o)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m41.37 29.22h4v4.73h-4z",
    fill: "url(#p)",
    transform: "matrix(.96597098 -.25865046 .25865046 .96597098 -6.69 12.29)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m34.02 32.26h4v4.73h-4z",
    fill: "url(#q)",
    transform: "matrix(.86611266 -.49984884 .49984884 .86611266 -12.49 22.64)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m27.71 37.1h4v4.73h-4z",
    fill: "url(#r)",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -19.21 32.57)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m22.87 43.41h4v4.73h-4z",
    fill: "url(#s)",
    transform: "matrix(.50015114 -.86593812 .86593812 .50015114 -27.21 44.42)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m19.82 50.76h4v4.73h-4z",
    fill: "url(#t)",
    transform: "matrix(.25865046 -.96597098 .96597098 .25865046 -35.14 60.46)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m18.42 59.01h4.73v4h-4.73z",
    fill: "url(#u)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m19.46 66.9h4.73v4h-4.73z",
    fill: "url(#v)",
    transform: "matrix(.97 -.26 .26 .97 -17.08 7.99)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5 74.25h4.73v4h-4.73z",
    fill: "url(#w)",
    transform: "matrix(.86611266 -.49984884 .49984884 .86611266 -34.79 22.64)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m27.34 80.56h4.73v4h-4.73z",
    fill: "url(#x)",
    transform: "matrix(.70723018 -.70698336 .70698336 .70723018 -49.67 45.17)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m70.79 80.19h4v4.73h-4z",
    fill: "url(#y)",
    transform: "matrix(.70735356 -.70685991 .70685991 .70735356 -37.05 75.62)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m75.63 73.88h4v4.73h-4z",
    fill: "url(#z)",
    transform: "matrix(.50015114 -.86593812 .86593812 .50015114 -27.22 105.34)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m78.68 66.54h4v4.73h-4z",
    fill: "url(#A)",
    transform: "matrix(.26 -.97 .97 .26 -6.75 129)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m79.36 59.01h4.73v4h-4.73z",
    fill: "url(#B)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m78.32 51.13h4.73v4h-4.73z",
    fill: "url(#C)",
    transform: "matrix(.97 -.26 .26 .97 -11 22.69)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m75.27 43.78h4.73v4h-4.73z",
    fill: "url(#D)",
    transform: "matrix(.8660254 -.5 .5 .8660254 -12.49 44.95)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m70.43 37.47h4.73v4h-4.73z",
    fill: "url(#E)",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -6.59 63.03)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m64.12 32.63h4.73v4h-4.73z",
    fill: "url(#F)",
    transform: "matrix(.49969767 -.86619988 .86619988 .49969767 3.27 74.91)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m56.77 29.58h4.73v4h-4.73z",
    fill: "url(#G)",
    transform: "matrix(.25898763 -.96588064 .96588064 .25898763 13.31 80.52)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUx);
export default __webpack_public_path__ + "static/media/icon_ux.6ffb3f533f45e9550993a5bca9e83d3d.svg";
export { ForwardRef as ReactComponent };